"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _subDays = _interopRequireDefault(require("date-fns/subDays"));

var _dayzed = _interopRequireDefault(require("dayzed"));

var _ = require("../");

var _CalendarNav = _interopRequireDefault(require("./components/CalendarNav"));

var _CalendarMonth = _interopRequireDefault(require("./components/CalendarMonth"));

var _excluded = ["monthNames", "weekdayNames", "monthsToDisplay", "stacked", "disabledDates", "interactiveDisabledDates", "firstDayOfWeek", "minDate"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var defaultWeekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

var DatePicker = function DatePicker(_ref) {
  var _ref$monthNames = _ref.monthNames,
      monthNames = _ref$monthNames === void 0 ? defaultMonthNames : _ref$monthNames,
      _ref$weekdayNames = _ref.weekdayNames,
      weekdayNames = _ref$weekdayNames === void 0 ? defaultWeekdayNames : _ref$weekdayNames,
      _ref$monthsToDisplay = _ref.monthsToDisplay,
      monthsToDisplay = _ref$monthsToDisplay === void 0 ? 1 : _ref$monthsToDisplay,
      _ref$stacked = _ref.stacked,
      stacked = _ref$stacked === void 0 ? false : _ref$stacked,
      _ref$disabledDates = _ref.disabledDates,
      disabledDates = _ref$disabledDates === void 0 ? [] : _ref$disabledDates,
      _ref$interactiveDisab = _ref.interactiveDisabledDates,
      interactiveDisabledDates = _ref$interactiveDisab === void 0 ? false : _ref$interactiveDisab,
      _ref$firstDayOfWeek = _ref.firstDayOfWeek,
      firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
      _ref$minDate = _ref.minDate,
      minDate = _ref$minDate === void 0 ? (0, _subDays["default"])(new Date(), 1) : _ref$minDate,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_dayzed["default"], (0, _extends2["default"])({}, rest, {
    firstDayOfWeek: firstDayOfWeek,
    minDate: minDate,
    monthsToDisplay: monthsToDisplay,
    render: function render(_ref2) {
      var calendars = _ref2.calendars,
          getBackProps = _ref2.getBackProps,
          getForwardProps = _ref2.getForwardProps,
          getDateProps = _ref2.getDateProps;
      if (!calendars.length) return null;
      return /*#__PURE__*/_react["default"].createElement(_.Box, {
        position: "relative"
      }, /*#__PURE__*/_react["default"].createElement(_CalendarNav["default"], {
        prevProps: getBackProps({
          calendars: calendars
        }),
        nextProps: getForwardProps({
          calendars: calendars
        })
      }), /*#__PURE__*/_react["default"].createElement(_.Flex, {
        flexWrap: "wrap",
        mx: 8
      }, calendars.map(function (calendar) {
        return /*#__PURE__*/_react["default"].createElement(_CalendarMonth["default"], {
          key: "".concat(calendar.month).concat(calendar.year),
          monthsToDisplay: monthsToDisplay,
          monthName: monthNames[calendar.month],
          month: calendar.month,
          year: calendar.year,
          stacked: stacked,
          weekdayNames: weekdayNames,
          weeks: calendar.weeks,
          getDateProps: getDateProps,
          disabledDates: disabledDates,
          interactiveDisabledDates: interactiveDisabledDates
        });
      })));
    }
  }));
};

DatePicker.propTypes = _objectSpread(_objectSpread({}, _dayzed["default"].propTypes), {}, {
  monthsToDisplay: _propTypes["default"].number,
  firstDayOfWeek: _propTypes["default"].number,
  stacked: _propTypes["default"].bool,
  minDate: _propTypes["default"].instanceOf(Date),
  disabledDates: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date)),
  interactiveDisabledDates: _propTypes["default"].bool,
  monthNames: _propTypes["default"].arrayOf(_propTypes["default"].string),
  weekdayNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
});
var _default = DatePicker;
exports["default"] = _default;